var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "flex flex-column",
    },
    [
      _c("PageScalingCard", {
        attrs: { header: _vm._f("trans")("product.search"), show: _vm.show },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("CommonList", {
                  ref: "productList",
                  attrs: {
                    categories: _vm.categories,
                    "empty-filter-text": "frontend.searching",
                    "empty-text": "product.no-results",
                    "error-text": "product.load-failed",
                    fields: _vm.fields,
                    "is-loading": _vm.isLoading,
                    "primary-key": "_uid",
                    "search-options": _vm.searchOptions,
                    "search-url": "app_api_product_search",
                    selector: true,
                  },
                  on: {
                    deselected: _vm.onProductDeselected,
                    highlight: _vm.onProductHighlighted,
                    search: function ($event) {
                      _vm.currentSearch = $event
                    },
                    selected: _vm.onProductSelected,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(stock)",
                        fn: function (row) {
                          return [
                            _c("ColoredStockNumber", {
                              attrs: { stock: row.value },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [_vm._t("actions", null, null, row)]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c("div", { staticClass: "product-info d-flex w-100 px-2" }, [
                  _c("div", { staticClass: "flex-grow-1 px-2" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.description")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.currentProduct.extended_description
                                    ) +
                                    "\n              "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.saleAmount")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.currentProduct.sale_amount) +
                                    "\n                " +
                                    _vm._s(
                                      _vm._f("trans")(
                                        "product.sale-amount-unit." +
                                          _vm.currentProduct.sale_amount_unit,
                                        {
                                          plural:
                                            _vm.currentProduct.sale_amount > 1,
                                        }
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.category.title")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.currentProduct.category.name) +
                                    "\n              "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.orderCode")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.currentProduct.order_code) +
                                    "\n              "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.location")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm.currentProduct._group
                                  ? [
                                      _vm._v(
                                        "\n                  -\n                "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.currentProduct.location.name
                                          ) +
                                          "\n                "
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.partNumber")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm.currentProduct._group
                                  ? [
                                      _vm._v(
                                        "\n                  -\n                "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.currentProduct.part_number
                                          ) +
                                          "\n                "
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.status")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.currentProduct.status.name) +
                                    "\n                "
                                ),
                                _vm.currentProduct.on_order
                                  ? [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("trans")("product.on-order")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("receipt.tax")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm.currentProduct._group
                                  ? [
                                      _vm._v(
                                        "\n                  -\n                "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.currentProduct.tax_category
                                              .percentage
                                          ) +
                                          "%\n                "
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.supplier")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                _vm.currentProduct._group
                                  ? [
                                      _vm._v(
                                        "\n                  -\n                "
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.currentProduct.supplier.name
                                          ) +
                                          "\n                "
                                      ),
                                    ],
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "title col-2" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("trans")("product.externalLink")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _vm.currentProduct
                            ? [
                                !!_vm.currentProduct.external_link
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.currentProduct
                                            .external_link,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("trans")("general.click")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-info-img align-self-center ml-1" },
                    [
                      _vm.currentProduct && _vm.currentProduct.image
                        ? [
                            _c("img", {
                              attrs: {
                                alt: _vm.currentProduct.order_code,
                                src: _vm.currentProduct.image,
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("KeyCapture", {
        attrs: { enabled: _vm.show },
        on: {
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.onCancel.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "f1", undefined, $event.key, undefined)
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.addProduct.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "f2", undefined, $event.key, undefined)
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.editProductPage.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "f3", undefined, $event.key, undefined)
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.openProductPage.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "f8", undefined, $event.key, undefined)
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.importCsv.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k(
                  $event.keyCode,
                  "insert",
                  undefined,
                  $event.key,
                  undefined
                )
              )
                return null
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.focusSearch.apply(null, arguments)
            },
          ],
        },
      }),
      _vm._v(" "),
      _vm._t("buttons", function () {
        return [
          _vm.forSale || _vm.forPurchase
            ? _c(
                "b-button-toolbar",
                { attrs: { justify: "" } },
                [
                  _c(
                    "b-button-group",
                    {
                      staticClass: "px-0 pr-md-1 col-md-4 col-sm-12 mb-sm-1",
                      attrs: { vertical: "" },
                    },
                    [
                      _vm.forPurchase
                        ? [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "light" },
                                on: { click: _vm.importCsv },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-fw fa-file-csv",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("trans")("purchase.import")) +
                                    " (F8)\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled:
                              _vm.currentSearch === "" && _vm.cancelDisabled,
                            variant: "danger",
                          },
                          on: { click: _vm.onCancel },
                        },
                        [
                          _c("i", { staticClass: "fas fa-fw fa-times" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("trans")(
                                  _vm.currentSearch === ""
                                    ? "form.cancel"
                                    : "frontend.clear-search"
                                )
                              ) +
                              " (esc)\n        "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button-group",
                    {
                      staticClass: "px-0 px-md-1 col-md-4 col-sm-12 mb-sm-1",
                      attrs: { vertical: "" },
                    },
                    [
                      _vm.forSale
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "light" },
                              on: { click: _vm.openProductPage },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-fw fa-book-open",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("trans")("sale.show-details")) +
                                  " (F3)\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.forPurchase
                        ? [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "light" },
                                on: { click: _vm.editProductPage },
                              },
                              [
                                _c("i", { staticClass: "fas fa-fw fa-edit" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("trans")("sale.edit-details")
                                    ) +
                                    " (F2)\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "light" },
                                on: { click: _vm.openProductPage },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-fw fa-book-open",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("trans")("sale.show-details")
                                    ) +
                                    " (F3)\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button-group",
                    {
                      staticClass: "px-0 pl-md-1 col-md-4 col-sm-12",
                      attrs: { vertical: "" },
                    },
                    [
                      _vm.forPurchase
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "light" },
                              on: { click: _vm.addProduct },
                            },
                            [
                              _c("i", { staticClass: "fas fa-fw fa-plus" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("trans")("purchase.add-product")
                                  ) +
                                  " (F1)\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "light" },
                          on: { click: _vm.focusSearch },
                        },
                        [
                          _c("i", { staticClass: "fas fa-fw fa-search" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("trans")("product.search")) +
                              " (ins)\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }